import React from 'react';
import Stack from '@mui/material/Stack';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import { SxProps } from '@mui/system';
const useStyles = makeStyles(
  (theme: Theme) => ({
    root: {
      maxWidth: '100%',
      minWidth: 'min( 400px, 100%)',
    },
  }),
  { name: 'FormSection' },
);

interface FormSectionProps {
  sx?: SxProps<Theme>;
}

const FormSection: React.FC<FormSectionProps> = ({ children, sx }) => {
  const classes = useStyles();

  return (
    <Stack sx={sx} className={classes.root} spacing={4}>
      {children}
    </Stack>
  );
};

export default FormSection;
